import React, { useState, useContext, useEffect } from "react";
import TaskAssignMembersMultiOwner from "../TaskAssignMember/TaskAssignMembersMultiOwner";
import { LoginContext } from "../../services/api/authentication-api";
import "./TaskAssignedMemberWrapper.scss";
import PropTypes from "prop-types";
import { getAllAssignedMembers, addMembersInForm, removeMembersInForm } from "./TaskAssignMemberWrapperHelper";

const TaskAssignMemberMultiOwnerWrapper = ({
  isCreate,
  task,
  taskMembers,
  projectMembers,
  selectedMembersEdit,
  selectedMembersView,
  selectedMembersApprove,
  setSelectedMembersEdit,
  setSelectedMembersView,
  setSelectedMembersApprove,
  selectedGroupEdit,
  selectedGroupView,
  selectedGroupApprove,
  setSelectedGroupEdit,
  setSelectedGroupView,
  setSelectedGroupApprove,
  selectedMembersOwner,
  setSelectedMembersOwner,
  selectedGroupsOwner,
  setSelectedGroupsOwner,
  workItemType,
  groupOwner,
  disabled,
}) => {
  const context = useContext(LoginContext);
  const [permissionTaskMembers, setPermissionTaskMembers] = useState([]);
  const [taskAssigned, setTaskAssigned] = useState(false);
  const [assignedMembers, setAssignedMembers] = useState([]);
  const [assignedOwners, setAssignedOwners] = useState([]);
  const [assignedOtherDepMembers, setAssignedOtherDepMembers] = useState([]);
  const [filterAssignedMembers, setFilterAssignedMembers] = useState([]);
  const [filteredOtherDepMembers, setFilteredOtherDepMembers] = useState([]);

  useEffect(() => {
    getAllAssignedMembers({
      taskMembers,
      projectMembers,
      context,
      isCreate,
      selectedMembersOwner,
      setAssignedOwners,
      setSelectedMembersOwner,
      setAssignedMembers,
      setAssignedOtherDepMembers,
      setPermissionTaskMembers,
      setFilterAssignedMembers,
      setFilteredOtherDepMembers
    });
  }, [taskMembers, projectMembers, taskAssigned, groupOwner]);

  const handleAddMembersInForm = (permission, id, isGroup = false) => {
    addMembersInForm({
      permission,
      id,
      isGroup,
      selectedMembers: {
        editor: selectedMembersEdit,
        viewer: selectedMembersView,
        approver: selectedMembersApprove,
        owner: selectedMembersOwner
      },
      selectedGroups: {
        editor: selectedGroupEdit,
        viewer: selectedGroupView,
        approver: selectedGroupApprove,
        owner: selectedGroupsOwner
      },
      setSelectedMembers: {
        editor: setSelectedMembersEdit,
        viewer: setSelectedMembersView,
        approver: setSelectedMembersApprove,
        owner: setSelectedMembersOwner
      },
      setSelectedGroups: {
        editor: setSelectedGroupEdit,
        viewer: setSelectedGroupView,
        approver: setSelectedGroupApprove,
        owner: setSelectedGroupsOwner
      }
    });
  };
  
  const handleRemoveMembersInForm = (permission, id, isGroup = false) => {
    removeMembersInForm({
      permission,
      id,
      isGroup,
      selectedMembers: {
        editor: selectedMembersEdit,
        viewer: selectedMembersView,
        approver: selectedMembersApprove,
        owner: selectedMembersOwner
      },
      selectedGroups: {
        editor: selectedGroupEdit,
        viewer: selectedGroupView,
        approver: selectedGroupApprove,
        owner: selectedGroupsOwner
      },
      setSelectedMembers: {
        editor: setSelectedMembersEdit,
        viewer: setSelectedMembersView,
        approver: setSelectedMembersApprove,
        owner: setSelectedMembersOwner
      },
      setSelectedGroups: {
        editor: setSelectedGroupEdit,
        viewer: setSelectedGroupView,
        approver: setSelectedGroupApprove,
        owner: setSelectedGroupsOwner
      }
    });
  };  

  const PermissionCheck = (permission) => {
    switch (permission) {
      case "owner":
        return task.AssignedMemberPermission?.CanChangeOwner
      case "editor":
        return task.AssignedMemberPermission?.CanChangeEditor
      case "viewer":
        return task.AssignedMemberPermission?.CanChangeViewer
      case "approver":
        return task.AssignedMemberPermission?.CanChangeApprover
      default:
        return false;
    }
  }

  return (
    <div className="TaskAssignMembersWrapper">
      <div className="wrapperHeader">Assign Members <span className="red">*</span></div>
      <div className="memberBox">
        <TaskAssignMembersMultiOwner
          assignedMembers={assignedOtherDepMembers}
          assignedOwner={assignedOwners}
          filteredAssignedMembers={filteredOtherDepMembers}
          addMembersInForm={handleAddMembersInForm}
          removeMembersInForm={handleRemoveMembersInForm}
          permissionTaskMembers={permissionTaskMembers}
          task={task}
          currUserId={context?.userID}
          ownerGroup={groupOwner}
          isDisabled={
            assignedOtherDepMembers?.length === 0 
            || (workItemType != null && workItemType.IsUsersEnabled === false) 
            || disabled
          }
          CanChangeApprover={isCreate || PermissionCheck("approver")}
          CanChangeEditor={isCreate || PermissionCheck("editor")}
          CanChangeViewer={isCreate || PermissionCheck("viewer")}
          CanChangeOwner={isCreate || PermissionCheck("owner")}
        />
      </div>
    </div>
  );
};

TaskAssignMemberMultiOwnerWrapper.propTypes = {
  isCreate: PropTypes.bool,
  task: PropTypes.object,
  taskMembers: PropTypes.array,
  projectMembers: PropTypes.array,
  selectedMembersEdit: PropTypes.array,
  selectedMembersView: PropTypes.array,
  selectedMembersApprove: PropTypes.array,
  setSelectedMembersEdit: PropTypes.func,
  setSelectedMembersView: PropTypes.func,
  setSelectedMembersApprove: PropTypes.func,
  selectedGroupEdit: PropTypes.array,
  selectedGroupView: PropTypes.array,
  selectedGroupApprove: PropTypes.array,
  setSelectedGroupEdit: PropTypes.func,
  setSelectedGroupView: PropTypes.func,
  setSelectedGroupApprove: PropTypes.func,
  selectedMembersOwner: PropTypes.array,
  setSelectedMembersOwner: PropTypes.func,
  selectedGroupsOwner: PropTypes.array,
  setSelectedGroupsOwner: PropTypes.func,
  groupOwner: PropTypes.object,
  disabled: PropTypes.bool,
  workItemType: PropTypes.shape({
    IsUsersEnabled: PropTypes.bool,
  }),
};
export default TaskAssignMemberMultiOwnerWrapper;
